export const MEDIA_QUERY_MOBILE = "(max-width:698px)";

export const CARGO_STATUS_PENDING_COLOR = "#c6cc14";
export const CARGO_STATUS_RESERVED_COLOR = "#ecff1c";
export const CARGO_STATUS_SHIPPED_COLOR = "#96b839";
export const CARGO_STATUS_ARRIVED_COLOR = "#2b8a03";
export const CARGO_STATUS_CLOSED_COLOR = "#26fc00";
export const CARGO_STATUS_DEPOSIT_COLOR = "#0961a9";
export const CARGO_STATUS_CANCELLED_COLOR = "#fc000d";
